<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LANeWp/tc-custom/9781626815766.jpg?1734324618896" alt="This image is the cover for the book Scandalous Lady"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scandalous Lady
      </h1>
      <p class="bookDescription body article font2">
        <b>In Regency England, an actress finds herself suddenly playing on a whole new stage . . .</b><br/>  <br/> Having risen from the squalor of London’s back alleys to be the darling of Drury Lane, Meg Fletcher was indeed the consummate actress. And it takes all her considerable skills to conceal her shock when she learns she was actually the legitimate daughter—and heir—of Sir Richard Carswell, an aging baronet . . .<br/>  <br/> Determined to learn why her mother fled her husband in terror all those years ago, Meg journeys to Carswell Hall. There, in addition to the scandalized servants and a very surprised papa, she encounters the extremely unsettling Earl of Stanbrook, a deliciously handsome rake—who is not at all amused when the actress he’d been intended to seduce began putting on airs at Carswell Hall in the role of virtuous prodigal daughter.<br/>  <br/> There was only one way a girl of her station could have come so far in the world. She might enjoy pretending she wasn’t to be won over with a few baubles, but he knew she was his for the taking. It would be trickier now that he knew she was of the Quality, but every gentleman understood there were ways to bend the rules when wooing a scandalous lady . . .<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karla Hocker
      </h2>
      
      <p class="authorDescription body article">Karla Hocker, a native of Germany, was the author of fourteen Regency novels and various novellas. She attributed her love of the English language and her fascination with the Regency period to a three-year stay in England. Hocker lived with her family&mdash;and far too many cats&mdash;in San Antonio, Texas. She passed away after a battle with cancer on May 28, 2004.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06cfa8e8